<template>
  <div>
    <b-card style="height:calc(100vh - 275px); overflow-y:auto;">
      <h3>Weighting</h3>
      <b-row>
        <b-col cols="6">
          <b-row>
            <b-col class="ml-4">
              <b-row v-for="(defaultIndicator, index) in defaultIndicatorsData" :key="index">
                <b-col>
                  <b-form-group
                    id="fieldset-1"
                    label-cols-sm="9"
                    label-cols-lg="8"
                    :label="defaultIndicator.text"
                    label-for="input-1"
                    class="text-left mt-3"
                  >
                    <b-form-input
                      onkeydown="return event.keyCode !== 69"
                      :disabled="!disableValues[defaultIndicator.key] || searchPage"
                      id="input-1"
                      type="number"
                      min="1"
                      max="100"
                      @input="onUpdateSumValues"
                      v-model="defaultIndicator.value"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!-- @change="onDisableValue($event, index)" -->

                <b-col cols="1">
                  <b-form-checkbox
                    :disabled="searchPage"
                    class="mt-3"
                    v-model="disableValues[defaultIndicator.key]"
                    @change="setDefaultIndicatorValue($event, defaultIndicator)"
                  ></b-form-checkbox>
                </b-col>
              </b-row>

              <!-- -----------------------------row for custom Attributes---------------- -->
              <div v-if="showCustomIndicators">
                <b-row
                  v-for="(indicator,index) in customIndicatorsData"
                  :key="indicator.indicatorTitle"
                >
                  <!-- :disabled="!indicator.show" -->

                  <b-col>
                    <b-form-group
                      label-cols-sm="9"
                      label-cols-lg="8"
                      :label="indicator.tp_customatt"
                      class="text-left text-capitalize"
                    >
                      <b-form-input
                        onkeydown="return event.keyCode !== 69"
                        type="number"
                        :disabled="!indicator.isActiveindicator || searchPage"
                        min="1"
                        max="100"
                        v-model="indicator.indicatorValue"
                        @input="onUpdateSumValues"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="1">
                    <!-- @change="onDisableDynamicValue($event, index)" -->

                    <b-form-checkbox
                      :disabled="searchPage"
                      class="mt-2"
                      v-model="indicator.isActiveindicator"
                      @change="setIndicatorValue($event, indicator)"
                    ></b-form-checkbox>
                  </b-col>
                </b-row>
              </div>

              <b-form-group
                :invalid-feedback="showSumError"
                id="fieldset-1"
                label-cols-sm="9"
                label-cols-lg="8"
                label="Total"
                class="text-left"
                style="margin-right: 40px;"
              >
                <b-form-input
                  :disabled="searchPage"
                  id="input-1"
                  :state="showSumError ? false : null"
                  type="number"
                  :value="totalSum"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6">
          <b-table-simple class="table">
            <b-thead>
              <b-tr>
                <b-th scope="col">Risk</b-th>
                <b-th scope="col">From</b-th>
                <b-th scope="col">To</b-th>
              </b-tr>
            </b-thead>

            <b-tbody>
              <b-tr>
                <b-td>
                  <b-badge variant="success">Low</b-badge>
                </b-td>
                <b-td>1</b-td>
                <b-td>
                  <b-form-input
                    :disabled="searchPage"
                    v-model="$store.state.priConfigrationforms.overallWeighting.lowerUpperLimit"
                    onkeydown="return event.keyCode !== 69"
                    type="number"
                    max="30"
                  ></b-form-input>
                </b-td>
              </b-tr>

              <b-tr>
                <b-td>
                  <b-badge variant="warning">Medium</b-badge>
                </b-td>
                <b-td>{{$store.state.priConfigrationforms.overallWeighting.lowerUpperLimit ? parseInt($store.state.priConfigrationforms.overallWeighting.lowerUpperLimit)+1 : 0}}</b-td>
                <b-td>
                  <b-form-input
                    :disabled="searchPage"
                    onkeydown="return event.keyCode !== 69"
                    v-model="$store.state.priConfigrationforms.overallWeighting.mediumUpperLimit"
                    type="number"
                    min="31"
                    max="75"
                  ></b-form-input>
                </b-td>
              </b-tr>
              <b-tr>
                <b-td>
                  <b-badge variant="danger">High</b-badge>
                </b-td>
                <b-td>{{$store.state.priConfigrationforms.overallWeighting.mediumUpperLimit ? parseInt($store.state.priConfigrationforms.overallWeighting.mediumUpperLimit)+1 : 0}}</b-td>
                <b-td>100</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "WeightingsComponent",
  data() {
    return {
      disableValues: {
        sanctions: true,
        negative: true,
        country: true,
        industry: true
      },
      totalSum: null,
      sumValues: [],
      showSumError: null
    };
  },
  mounted() {
    this.onUpdateSumValues();
  },
  methods: {
    setIndicatorValue(e, value) {
      if (e) {
        this.onUpdateSumValues();
        return;
      } else {
        value.indicatorValue = null;
        this.onUpdateSumValues();
      }
    },
    setDefaultIndicatorValue(e, value) {
      if (e) {
        this.onUpdateSumValues();
        return;
      } else {
        value.value = null;
        this.onUpdateSumValues();
      }
    },
    onUpdateSumValues() {
      this.getSumOfAllValues();
    },

    getSumOfAllValues() {
      // let options = this.fieldData.options;
      let sumOfDefaultIndicatorsValues = _.sumBy(
        this.defaultIndicatorsData,
        function(o) {
          return parseInt(o.value) || 0;
        }
      );

      let sumOfIndicatorsValues = _.sumBy(this.customIndicatorsData, function(
        o
      ) {
        return parseInt(o.indicatorValue) || 0;
      });

      // indicators[index].indicatorValue
      // let sumOfAllValues = (parseInt(this.negativeValue)  + parseInt(this.countryValue) + parseInt(this.industryValue) + sumOfIndicatorsValues)
      let sumOfAllValues = sumOfDefaultIndicatorsValues + sumOfIndicatorsValues;

      if (sumOfAllValues > 100) {
        this.showSumError = "This value cannot be grater than 100";
        this.totalSum = sumOfAllValues;
      } else {
        this.showSumError = null;
        this.totalSum = sumOfAllValues;
      }
    }
  },
  props: {
    showCustomIndicators: Boolean,
    defaultIndicatorsData: Array,
    customIndicatorsData: Array,
    searchPage: Boolean
  }
};
</script>